import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "arrow-down-circle-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(1.5 1.5)" },
        React.createElement("path", { fill: "currentColor", stroke: "currentColor", strokeLinejoin: "round", d: "m7 10 2-2H5z" }),
        React.createElement("circle", { cx: 7, cy: 7, r: 7, stroke: "currentColor" }),
        React.createElement("path", { fill: "currentColor", fillRule: "nonzero", d: "M7.5 9.5a.5.5 0 1 1-1 0V4a.5.5 0 0 1 1 0v5.5Z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
